import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

export interface EditGebaeudeData {
  id: string;
  name: string;
  standortId: string;
}

@Component({
  selector: 'app-edit-gebaeude-dialog',
  templateUrl: './edit-gebaeude-dialog.component.html',
  styleUrls: ['./edit-gebaeude-dialog.component.css'],
})
export class EditGebaeudeDialogComponent implements OnInit {
  frmGebaeude: UntypedFormGroup;
  gebaeudeId: string;
  standortId: string;

  constructor(
    public dialogRef: MatDialogRef<EditGebaeudeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditGebaeudeData,
    private _fb: UntypedFormBuilder
  ) {
    this.gebaeudeId = data.id;
    this.standortId = data.standortId;

    this.frmGebaeude = this._fb.group({
      name: [data.name, [Validators.required, Validators.minLength(2)]],
      standort_id: [this.standortId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmGebaeude.valid) {
      this.dialogRef.close({ 
        event: 'update', 
        data: {
          id: this.gebaeudeId,
          ...this.frmGebaeude.value
        }
      });
    }
  }

  onDelete(): void {
    const confirmed = confirm('Sind Sie sicher, dass Sie dieses Gebäude deaktivieren möchten? Es wird als inaktiv markiert und in der Historie angezeigt.');
    if (confirmed) {
      this.dialogRef.close({ 
        event: 'delete', 
        data: { 
          id: this.gebaeudeId,
          name: this.frmGebaeude.get('name')?.value || this.data.name
        }
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}

